<template>
  <div class="container">
    <el-container>
      <el-aside width="230px" class="aside">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-vertical"
          @select="handleAsideSelect"
          background-color="#545c64"
          text-color="#fff"
          active-text-color="#ffd04b"
        >
          <el-sub-menu
            v-for="menu in formattedMenus"
            :key="menu.menu_index"
            :index="menu.menu_index"
          >
            <template #title>
              <!-- 使用 component :is 来动态渲染图标 -->
              <el-icon>
                <component :is="icons[menu.menu_icon]" />
              </el-icon>
              <span>{{ menu.title }}</span>
            </template>
            <el-menu-item
              v-for="item in menu.children"
              :key="item.menu_index"
              :index="item.menu_index"
              @click="navigateTo(item.path)"
            >
              <!-- 使用 component :is 来动态渲染图标 -->
              <el-icon>
                <component :is="icons[item.menu_icon]" />
              </el-icon>
              {{ item.title }}
            </el-menu-item>
          </el-sub-menu>
        </el-menu>
      </el-aside>
      <el-container>
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { ElMessageBox, ElMessage } from 'element-plus';
import axios from 'axios';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';

export default {
  name: 'HomePage',
  components: {
    ...ElementPlusIconsVue,
  },
  data() {
    return {
      activeIndex: '1',
      menus: [],
      icons: ElementPlusIconsVue,
      systemTitle: '', // 存储系统标题
      logoSrc: '', // Logo图片的URL
    };
  },
  computed: {
    formattedMenus() {
      const menus = this.menus.reduce((acc, cur) => {
        if (!cur.father) {
          acc[cur.menu_index] = { ...cur, children: [] };
        } else {
          acc[cur.father].children.push(cur);
        }
        return acc;
      }, {});
      return Object.values(menus);
    },
  },
  methods: {
    fetchMenus() {
      axios.get('/api/menus')
        .then(response => {
          this.menus = response.data;
        })
        .catch(error => {
          console.error("There was an error fetching the menus:", error);
        });
    },
    navigateTo(path) {
      if (path) {
        this.$router.push(path);
      }
    },
    handleAsideSelect(selectedIndex) {
      console.log("Selected index:", selectedIndex);
    },
    confirmLogout() {
      ElMessageBox.confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.post('/api/logout')
          .then(response => {
            if (response.data.success) {
              ElMessage({
                type: 'success',
                message: '退出登录成功',
              });
              this.$router.push('/login');
            } else {
              ElMessage({
                type: 'error',
                message: '退出登录失败',
              });
            }
          })
          .catch(() => {
            ElMessage({
              type: 'error',
              message: '退出登录失败',
            });
          });
      }).catch(() => {
        // 取消操作
      });
    },
    fetchSystemTitleAndLogo() {
      // 获取系统标题
      axios.get('/api/system-title').then(response => {
        this.systemTitle = response.data.title;
        document.title = this.systemTitle; // 设置页面标题为系统标题
      }).catch(error => {
        console.error('Error fetching system title:', error);
      });

      // 获取Logo并更新Favicon
      axios.get('/api/logo', { responseType: 'blob' }).then(response => {
        const logoUrl = URL.createObjectURL(response.data);
        this.logoSrc = logoUrl;
        this.updateFavicon(logoUrl); // 更新favicon
      }).catch(error => {
        console.error('Error fetching logo:', error);
      });
    },
    updateFavicon(logoUrl) {
      let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = logoUrl;
      document.getElementsByTagName('head')[0].appendChild(link);
    },
  },
  mounted() {
    this.fetchMenus();
    this.fetchSystemTitleAndLogo(); // 在组件加载时获取系统标题和Logo
  }
};
</script>

<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
.flex-grow {
  flex-grow: 2;
}
.container {
  display: flex;
  height: 100vh;
  margin: 0; /* 确保没有外部边距 */
  padding: 0; /* 确保没有内部填充 */
  box-sizing: border-box;
}

.header {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  border-bottom: none; /* 确保没有底部边框 */
  box-shadow: none; /* 确保没有阴影 */
}

.header .el-menu-horizontal {
  margin: 0; /* 确保没有外部边距 */
  padding: 0; /* 确保没有内部填充 */
  border-bottom: none; /* 去掉底部边框 */
}

.aside {
  height: 100%; /* 使 aside 高度与容器相同 */
  position: relative; /* 确保内部元素相对于 aside 定位 */
}

.aside .el-menu-vertical {
  height: 100%; /* 使垂直菜单占据 aside 的全部高度 */
  position: absolute; /* 绝对定位以顶格 */
  top: 0;
  left: 0; /* 靠左顶格 */
}

.main {
  flex: 1; /* 使 main 占据剩余空间 */
  padding: 20px; /* 可以根据需要添加内边距 */
}
</style>